import { Injectable } from '@angular/core';
import { ActionItem, ApiFragment, PerformedAction } from '@stylehaven/components';
import { Observable } from 'rxjs';
import { ActionItemOptions } from '../../common/entities/common/action-item-function.entity';

@Injectable({ providedIn: 'root' })
export abstract class PreviewDialogActionsService {
    abstract getActionItems(record: ApiFragment, actionItemOptions: ActionItemOptions): Observable<ActionItem[]>;
    abstract getPerformedActions(): Observable<PerformedAction<ApiFragment>>;
}
